"use client";

import { Fragment } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export interface QuoteFlowCrumb {
  key: string;
  label: string;
  onClick?: () => void;
}

interface QuoteFlowBreadcrumbsProps {
  crumbs: QuoteFlowCrumb[];
  className?: string;
}

export function QuoteFlowBreadcrumbs({
  crumbs,
  className,
}: QuoteFlowBreadcrumbsProps) {
  if (crumbs.length <= 1) return null;

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <Fragment key={crumb.key}>
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem>
                {crumb.onClick ? (
                  <BreadcrumbLink asChild className="text-action font-medium">
                    <button type="button" onClick={crumb.onClick}>
                      {crumb.label}
                    </button>
                  </BreadcrumbLink>
                ) : isLast ? (
                  <BreadcrumbPage className="font-medium">
                    {crumb.label}
                  </BreadcrumbPage>
                ) : (
                  <span className="text-muted-foreground font-medium">
                    {crumb.label}
                  </span>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
